import { EnvironmentConfig, EnvironmentVariables } from './environment.types';
import { developmentConfig } from './environment.development';
import { productionConfig } from './environment.production';

const getEnvironmentConfig = (): EnvironmentConfig => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return productionConfig;
    case 'development':
      return developmentConfig;
    default:
      return developmentConfig;
  }
};

const environmentConfig = getEnvironmentConfig();

export const environment: EnvironmentVariables = {
  ...environmentConfig,
  isProduction: environmentConfig.ENV === 'production',
  isDevelopment: environmentConfig.ENV === 'development',
  isStaging: environmentConfig.ENV === 'staging',
};

// Validate environment variables
const validateEnvironment = () => {
  const requiredVars: (keyof EnvironmentConfig)[] = [
    'API_URL'
  ];

  const missingVars = requiredVars.filter((key) => !environment[key]);

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}`
    );
  }
};

if (process.env.NODE_ENV !== 'test') {
  validateEnvironment();
}
